import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, BarChart3 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const LOGO_URL = `${process.env.REACT_APP_BACKEND_URL}/api/static/kpl-logo-color.png`;
const LOGO_WHITE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/static/kpl-logo-white.png`;

export default function Stats() {
  const [stats, setStats] = useState(null);
  const [tab, setTab] = useState("batting");

  useEffect(() => {
    axios.get(`${API}/stats/players`).then((r) => setStats(r.data)).catch(() => setStats({ batting: [], bowling: [] }));
  }, []);

  return <div className="gallery-wrap live-wrap">
    <div className="container">
      <div className="gallery-top">
        <img className="auth-logo gallery-logo" src={LOGO_WHITE_URL} alt="KPL logo" data-testid="stats-logo" />
        <Link className="auth-home gallery-back" to="/" data-testid="stats-back-home"><ArrowLeft size={15} /> BACK TO SITE</Link>
      </div>
      <div className="gallery-head">
        <p className="eyebrow blue">KPL SEASON ONE</p>
        <h1 className="gallery-title">Season stats.</h1>
      </div>
      <div className="gallery-tabs" data-testid="stats-tabs">
        <button className={`gallery-tab ${tab === "batting" ? "active" : ""}`} onClick={() => setTab("batting")} data-testid="stats-tab-batting">Batting</button>
        <button className={`gallery-tab ${tab === "bowling" ? "active" : ""}`} onClick={() => setTab("bowling")} data-testid="stats-tab-bowling">Bowling</button>
      </div>

      {!stats ? <p className="reg-empty">Loading stats…</p> : (tab === "batting" ? stats.batting : stats.bowling).length === 0 ? <div className="gallery-empty" data-testid="stats-empty">
        <BarChart3 size={40} />
        <h3>No stats yet</h3>
        <p>Player rankings build automatically from officially scored matches once the season begins.</p>
      </div> : <div className="sc-table-wrap stats-table" data-testid="stats-table">
        {tab === "batting" ? <table className="sc-table"><thead><tr><th>#</th><th>Player</th><th>Inns</th><th>Runs</th><th>Best</th><th>Avg</th><th>SR</th><th>4s</th><th>6s</th></tr></thead>
          <tbody>{stats.batting.map((p) => <tr key={p.name} className={p.rank === 1 ? "cap-leader" : ""} data-testid={`bat-row-${p.rank}`}>
            <td>{p.rank === 1 && <i className="cap-dot orange" />}{p.rank}</td><td>{p.name}</td><td>{p.innings}</td><td><b>{p.runs}</b></td><td>{p.best}</td><td>{p.avg}</td><td>{p.sr}</td><td>{p.fours}</td><td>{p.sixes}</td>
          </tr>)}</tbody></table>
        : <table className="sc-table"><thead><tr><th>#</th><th>Player</th><th>Inns</th><th>Overs</th><th>Runs</th><th>Wkts</th><th>Best</th><th>Econ</th></tr></thead>
          <tbody>{stats.bowling.map((p) => <tr key={p.name} className={p.rank === 1 ? "cap-leader" : ""} data-testid={`bowl-row-${p.rank}`}>
            <td>{p.rank === 1 && <i className="cap-dot purple" />}{p.rank}</td><td>{p.name}</td><td>{p.innings}</td><td>{p.overs}</td><td>{p.runs}</td><td><b>{p.wickets}</b></td><td>{p.best}</td><td>{p.econ}</td>
          </tr>)}</tbody></table>}
      </div>}
    </div>
  </div>;
}
